import { handleResponse } from "../../helpers/handleresponse";
import { authHeader } from "../../helpers/authHeader";

export const attendeeService = {
  getOrdersByBadgeNo, 
}

async function getOrdersByBadgeNo(badgeNo) {
    const requestOptions = {
      method: "GET",
      headers: authHeader({ "Content-Type": "application/json" })
  
    };
    return fetch(`./api/attendee/${badgeNo}`, requestOptions)
      .then(handleResponse)
      .then(orderList => {
        return orderList;
      });
  }